module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/cosmic_client.afbeac33.png";